import { r4Client, r4Error } from '@/services'
import useLogger from '@/composables/useLogger'
const logger = useLogger('OmniSearchApi')

const OmniSearchApi = {
  /**
   * Create data to generate a report
   * @param {Object} reportParams
   */
  async search (dealerId, searchTerm) {
    const term = searchTerm.toString().trim().replace(/[^a-zA-Z0-9]+/g, '%')
    logger.trace('IN:', searchTerm, 'OUT:', term)
    try {
      const resp = await r4Client().get('/api/v1/query_engine/search', { params: { dealer_id: dealerId, search_term: term } })
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  },
  async show (dealerId, customerId, detailType) {
    if (!['contact', 'transaction'].includes(detailType)) {
      throw new Error(`Unknown detailType ${detailType}. detailType must be one of ['contact', 'transaction']`)
    }

    try {
      const resp = await r4Client().get(`/api/v1/query_engine/search/${customerId}`, { params: { dealer_id: dealerId, detail_type: detailType } })
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  }
}

export default OmniSearchApi
